import moment from 'moment';

export function toMoment(_values) {
  const values = Object.assign({}, _values);

  if (values.activityEndTime && values.activityStartTime) {
    values.activityTime = [moment(values.activityStartTime), moment(values.activityEndTime)];
    delete values.activityStartTime;
    delete values.activityEndTime;
  }
  if (values.highStartTime && values.highEndTime) {
    values.highTime = [moment(values.highStartTime), moment(values.highEndTime)];
    delete values.highStartTime;
    delete values.highEndTime;
  }

  if (values.preStartTime && values.preEndTime) {
    values.preTime = [moment(values.preStartTime), moment(values.preEndTime)];
    delete values.preStartTime;
    delete values.preEndTime;
  }

  // 返场期
  if (values.backStartTime && values.backEndTime) {
    values.backTime = [moment(values.backStartTime), moment(values.backEndTime)];
    delete values.backStartTime;
    delete values.backEndTime;
  }

  if (values.specialStartTime && values.specialEndTime) {
    values.specialTime = [moment(values.specialStartTime), moment(values.specialEndTime)];
    delete values.specialStartTime;
    delete values.specialEndTime;
  }

  // values.activityPlanRooms = values.activityPlanRooms && values.activityPlanRooms.slice();

  // values.activityPlanRooms &&
  //   (values.activityPlanRooms = values.activityPlanRooms.map((item) => {
  //     const _item = Object.assign({}, item);
  //     if (_item.startTime && _item.endTime) {
  //       _item.time = [moment(_item.startTime), moment(_item.endTime)];
  //       delete _item.startTime;
  //       delete _item.endTime;
  //     }
  //     return _item;
  //   }));
  return values;
}

export function toTimeStamp(_values) {
  const values = Object.assign({}, _values);
  const transformTime = (moment) => Math.floor(moment.valueOf() / 1000) * 1000;

  if (values.activityTime) {
    values.activityStartTime = transformTime(values.activityTime[0]);
    values.activityEndTime = transformTime(values.activityTime[1]);
  }

  delete values.activityTime;

  if (values.highTime) {
    values.highStartTime = transformTime(values.highTime[0]);
    values.highEndTime = transformTime(values.highTime[1]);
  }

  delete values.highTime;

  if (values.preTime) {
    values.preStartTime = transformTime(values.preTime[0]);
    values.preEndTime = transformTime(values.preTime[1]);
  }

  delete values.preTime;

  if (values.specialTime) {
    values.specialStartTime = transformTime(values.specialTime[0]);
    values.specialEndTime = transformTime(values.specialTime[1]);
  }

  delete values.specialTime;

  if (values.backTime) {
    values.backStartTime = transformTime(values.backTime[0]);
    values.backEndTime = transformTime(values.backTime[1]);
  }

  delete values.backTime;

  // values.activityPlanRooms = values.activityPlanRooms && values.activityPlanRooms.slice();

  // values.activityPlanRooms &&
  //   (values.activityPlanRooms = values.activityPlanRooms.map((item) => {
  //     const _item = Object.assign({}, item);
  //     if (_item.time) {
  //       _item.startTime = transformTime(_item.time[0]);
  //       _item.endTime = transformTime(_item.time[1]);
  //       delete _item.time;
  //     }

  //     return _item;
  //   }));

  return values;
}
